export enum Info {
  success = 'success',
  error = 'error',
  default = 'default'
}
